import React, { useEffect } from "react";
import { Heading } from "../../../subComponents/Heading";
import { VisionCard } from "./subComponents/visionCard";
import { ContentCard } from "./subComponents/contentCard";
import AOS from "aos";
import "aos/dist/aos.css";

const VisionMissionSection = () => {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <>
      <section className="vision_mission_section">
        <section className="vision_section">
          <Heading
            orangeheading={"VISION AND MISSION"}
            title={``}
            data-aos="zoom-in"
            style={{ textAlign: "center", marginTop: "1rem" }}
          />
          <div className="vision_container" style={{ overflowX: "hidden" }}>
            <VisionCard title={"Vision"}   imgUrl={"/assets/images/AboutUs/vision.png"} />
            <ContentCard
              title={<>Vision</>}
              content={
                <>
                  TUBE FLEX INDIA firmly believes in consistency in quality of
                  international standards at the most competitive price.
                </>
              }
            />
          </div>
        </section>

        <section className="mission_section">
          <div
            className="vision_container mission_container"
            style={{ overflowX: "hidden" }}
          >
            <ContentCard
              title={"Mission"}
              content={
                <>
                  To become a market leader in extrusion profile and hose &
                  nylon hose assemblies.
                </>
              }
            />
            <VisionCard title={"Mission"} imgUrl={"/assets/images/AboutUs/mission.png"} />
          </div>
        </section>
      </section>
    </>
  );
};
export { VisionMissionSection };
